import { FC, ReactNode } from 'react';
import { classNames } from 'src/shared/lib/helpers/classNames';
import cls from './Title.module.scss';

export const TitleSize = {
  XS: 'xs',
  S: 's',
  M: 'm',
  L: 'l'
} as const;

type TitleSizeT = typeof TitleSize[keyof typeof TitleSize];
interface ITitle {
  children: ReactNode;
  className?: string;
  size?: TitleSizeT
  align?: 'left' | 'center' | 'right';
}

export const Title: FC<ITitle> = ({
  children, className, size = TitleSize.M, align = 'left'
}) => (
  <h2 className={classNames(cls.title, {}, [className, cls[size], cls[align]])}>{children}</h2>
);
